export default __webpack_public_path__ + "static/media/SWT1200.34I-35662_-21624_0.462e85b7.jpg";